export const ourPartners = {
  title: "Partnership",
};
